import { useTable, usePagination } from 'react-table'
import FWOTablePagination from './FWOTablePagination'

interface Props {
  id: string
  columns: any
  data: any
  onRowClicked: (row) => void
}

const FWOTable = (props: Props) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns: props.columns,
      data: props.data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    usePagination
  )

  return (
    <>
      <table {...getTableProps()} id={props.id}>
        <thead>
          {headerGroups.map((headerGroup, index) => (
            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => {
                return column.hideHeader === true ? null : (
                  <th key={index} {...column.getHeaderProps()}>
                    {column.render('Header')}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row)
            return (
              <tr
                tabIndex={0}
                key={index}
                {...row.getRowProps({
                  onClick: () => {
                    props.onRowClicked && props.onRowClicked(row)
                  },
                  onKeyPress: (evt) => {
                    if (evt.charCode == 13) {
                      props.onRowClicked && props.onRowClicked(row)
                    }
                  },
                })}
              >
                {row.cells.map((cell, index) => {
                  return (
                    <td key={index} {...cell.getCellProps()}>
                      {cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
      <FWOTablePagination
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        previousPage={previousPage}
        canPreviousPage={canPreviousPage}
        nextPage={nextPage}
        canNextPage={canNextPage}
      />
    </>
  )
}

export default FWOTable
